import { render, staticRenderFns } from "./MicVolumeIndication.vue?vue&type=template&id=16b163fd&scoped=true&"
import script from "./MicVolumeIndication.vue?vue&type=script&lang=js&"
export * from "./MicVolumeIndication.vue?vue&type=script&lang=js&"
import style0 from "./MicVolumeIndication.vue?vue&type=style&index=0&id=16b163fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b163fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b163fd')) {
      api.createRecord('16b163fd', component.options)
    } else {
      api.reload('16b163fd', component.options)
    }
    module.hot.accept("./MicVolumeIndication.vue?vue&type=template&id=16b163fd&scoped=true&", function () {
      api.rerender('16b163fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MicVolumeIndication.vue"
export default component.exports